import { ViewModel } from '../view-model';
import { CommercialImpactItem } from './commercial-impact-item';

export class CommercialImpacts implements ViewModel {
  friendlyTypeNameSingular: string = 'Commercial Impact';
  apiRoute: string;

  id: string;
  productionStreamId: string;
  productionStream: CommercialImpactItem = new CommercialImpactItem();
  laborId: string;
  labor: CommercialImpactItem = new CommercialImpactItem();
  materialId: string;
  material: CommercialImpactItem = new CommercialImpactItem();
  otherId: string;
  other: CommercialImpactItem = new CommercialImpactItem();

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;

    if (data.productionStream) {
      this.productionStream.loadFromJson(data.productionStream);
      this.productionStreamId = this.productionStream.id;
    }

    if (data.labor) {
      this.labor.loadFromJson(data.labor);
      this.laborId = this.labor.id;
    }

    if (data.material) {
      this.material.loadFromJson(data.material);
      this.materialId = this.material.id;
    }

    if (data.other) {
      this.other.loadFromJson(data.other);
      this.otherId = this.other.id;
    }
  }
}
